export default __webpack_public_path__ + "static/media/transportation.75561934.jpeg";